export default "__VITE_ASSET__CJs$NNUF__"